module.exports = __webpack_public_path__ + "img/广告.e61dab21.png";